const parseStringFromHtml = (html) => {
  const convertToTextWithLineBreaks = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    let output = "";
    tempDiv.childNodes.forEach((node) => {
      if (node.nodeName === "P") {
        output += (output ? "\n" : "") + node.textContent.trim(); // Add newline between paragraphs
      } else {
        output += node.textContent.trim();
      }
    });

    return output;
  };

  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  const mathFields = tempDiv.querySelectorAll("math-field");
  mathFields.forEach((mathField) => {
    const latex = mathField.textContent; // Get the latex content
    mathField.outerHTML = `\\( ${latex} \\)`;
  });

  return convertToTextWithLineBreaks(
    tempDiv.innerHTML.replace(/<\/?math-field[^>]*>/g, "")
  );
};

export default parseStringFromHtml;
